<!--  -->
<template>
  <div :class="['my-container', showMyAccount ? 'show-cart' : '']">
    <div class="nav pc_nav">
      <ul class="user-nav">
        <div class="user-name">
          欢迎
          <span>{{ tb_user_name }}</span>
        </div>
        <li
          v-if="item.show"
          v-for="(item, index) in accountList"
          :key="index"
          :class="[
            'user-item',
            ($route.fullPath == item.path && hoverMenu) ||
            (showOrderDetail && index == 3)
              ? 'herf_tilte'
              : '',
          ]"
        >
          <a @click="goRouter(item.path)">{{ item.page }}</a>
        </li>
        <li class="user-item exit" @click="exit()">退出</li>
      </ul>
    </div>
    <div class="mb_nav">
      <Select :label-in-value="true" v-model="model1" @on-change="change_status">
        <Option
          v-if="item.show"
          v-for="(item, index) in accountList"
          :key="index"
          :value="item.path"
        >{{ item.page }}</Option>
      </Select>
    </div>
    <div
      :class="[
        'nav-content',
        $route.path == '/account/order-detail' 
          ? 'order-content'
          : '',
      ]"
    >
      <router-view name="menuView"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: "",
      accountList: [
        {
          page: "个人信息",
          title: "个人信息",
          path: "/account/user-info",
          show: true
        },
        {
          page: "订阅偏好",
          title: "订阅偏好",
          path: "/account/email-setting",
          show: true
        },
        {
          page: "地址簿",
          title: "地址簿",
          path: "/account/address-list",
          show: true
        },
        {
          page: "订单",
          title: "订单",
          path: "/account/order-list?tab=new",
          show: true
        },
        {
          page: "愿望清单",
          title: "愿望清单",
          path: "/account/love-list",
          show: true
        },
        {
          page: "订单详情",
          title: "订单详情",
          path: "/account/order-detail",
          show: false
        }
      ],
      model1: "/account/user-info"
    };
  },
  props: {
    accountType: {
      type: Number,
      default: 0
    },
    hoverMenu: {
      type: Boolean,
      default: true
    },
    showMyAccount: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showOrderDetail() {
      return this.$store.state.showOrderDetail;
    },
    tb_user_name() {
      return this.$store.state.tb_user_name;
    },
    RefreshAcountNav() {
      return this.$store.state.RefreshAcountNav;
    }
  },
  watch: {
    "$route.path": function(newVal, oldVal) {
      // this.getUserInfo(); //检测是否token过期
    },
    RefreshAcountNav(curVal, oldVal) {
      this.model1 = this.$route.path;
      if (this.$route.path == "/account/order-list") {
        this.$router.push({ path: this.$route.path + "?tab=new" });
      } else {
        this.$router.push({ path: this.$route.path });
      }
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.model1 = this.$route.path;
    if (this.model1.indexOf("/account") > -1) {
      this.getUserInfo();
    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    var userinfo = JSON.parse(window.localStorage.getItem("userInfo"));
    if (userinfo) {
      this.userName = userinfo.name;
      this.$store.commit("setValue", ["tb_user_name", this.userName]);
    }
  },
  methods: {
    getUserInfo() {
      var that = this;
      var url = that.$store.state.API.my.getUserInfo;
      this.$http
        .get(url, {
          headers: { tb_token: window.localStorage.getItem("token") }
        })
        .then(res => {
          if (res.data.returnCode == "005" && !res.data.result) {
            //没有登录 或是失效
            this.exit();
          } else {
            // this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },
    repeatRouter(path) {
      if (path == this.$route.path) {
        this.$router.go(0);
      } else {
        this.$router.path(path);
      }
    },
    change_status(data) {
      if (!data) return;
      var val = data.value;
      let Option = this.accountList.filter(function(item, index, array) {
        return item.path === val;
      });
      var path = Option[0].path;
      this.$nextTick(() => {
        if (path == "/account/order-list") {
          this.$router.push({ path: path + "?tab=new" });
        } else {
          this.$router.push({ path: path });
        }
      });
    },
    forgetPassword() {
      this.showForgetPassword = true;
    },
    exit() {
      if (this.accountType == 1) {
        this.$emit("exit");
      } else {
        window.localStorage.removeItem("userInfo");
        window.localStorage.removeItem("token");
        let isExitlogin = !this.$store.state.isExitlogin;
        this.$store.commit("UpdateLoginStatus", isExitlogin);
        this.$store.commit("upDateLoveCount", 0);
        this.$store.commit("upDateShopCount", 0);
        this.$store.commit("setValue", ["userLogin", false]);
        // this.$store.commit("setValue", ["userLogin", true]);
        this.$router.push({ name: "home" });
      }
    },
    goRouter(_r) {
      let isClickAcount = this.$store.state.isClickAcount;
      this.$store.commit("RefreshAcountMeau", !isClickAcount);
      // this.$router.push({ path: _r });
      if (_r == this.$route.path) {
        this.$router.go(0);
      } else {
        if (_r == "/account/order-list") {
          this.$router.push({ path: _r + "?tab=new" });
        } else {
          this.$router.push({ path: _r });
        }
      }
    }
  }
};
</script>
<style lang="less">
/* @import url(); 引入css类 */
.my-container {
  padding: 3.9rem 14rem 5rem;
  display: flex;
  flex-direction: row;
  opacity: 0;
  visibility: hidden;
  &.show-cart {
    opacity: 1;
    visibility: visible;
  }
  .pc_nav {
    display: block;
  }
  .mb_nav {
    display: none;
  }
  .nav {
    flex: 1;

    .user-nav {
      margin-right: 5rem;
      padding: 2rem;
      border: 0.1rem solid #eaeaea;
      text-align: left;
      line-height: 2.4rem;
      font-size: 1.3rem;
      .user-name {
        display: none;
      }
      ul {
        margin-right: 5rem;
        padding: 2rem;
        border: 0.1rem solid #eaeaea;
        li {
          margin-bottom: 1rem;
          a {
            color: red;
          }

          a:hover {
            background: red;
            text-decoration: initial;
          }
        }
      }
      .exit {
        margin-top: 3.4rem;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .nav-content {
    flex: 3;
    text-align: left;

    border: 0.1rem solid #eaeaea;
    &.order-content {
      border: none !important;
    }
  }
}
@media screen and (max-width: 1024px) {
  .my-container {
    padding: 0 3rem 1.5rem;
    margin-top: 1.5rem;

    .nav-content {
      // margin: 0 2rem 2rem;
      //
      border-top: 0.1rem solid #eaeaea;
      &.order-content {
        margin: 0;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .my-container {
    padding: 0;
    flex-direction: column;

    .pc_nav {
      display: none;
    }
    .mb_nav {
      display: block;
      margin-bottom: 2rem;
      display: flex;
      align-items: baseline;
      padding: 0 2rem;
    }
    .nav-content {
      border: none;
    }
  }
}
/deep/.router-link-exact-active router-link-active {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Account.vue